import { useEffect, useState, type ReactNode } from 'react';

/**
 * Motion tokens (Phase 0 redesign): 150-250ms ease-out, 8px translate+fade.
 * Wraps a wizard step's content so switching `step` re-mounts (via the
 * caller's `key`) and reveals instead of hard-cutting — same enter-only
 * pattern Toast already uses (apps/dispatcher/src/components/ui/toast.tsx):
 * start offset+transparent, flip on the next tick so the browser animates
 * the transition rather than painting the end state immediately. No exit
 * animation (matches Toast's own precedent, and there's nothing to unmount
 * once the wizard has moved on).
 */
export function StepReveal({ children }: { children: ReactNode }) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShown(true), 10);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      className={`transition-all duration-200 ease-out ${
        shown ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      }`}
    >
      {children}
    </div>
  );
}
